import PlusIcon from 'lib/images/PlusIcon';
import SaveIcon from 'lib/images/SaveIcon';
import UploadIcon from 'lib/images/UploadIcon';
import { theme } from 'lib/style';
import React from 'react';

export const btnProps = {
  borderRadius: 6,
  height: '40px',
  fontSize: '15px',
  margin: '0px',
};

export const saveBtnProps = {
  textColor: theme.palette.white,
  text: 'Save Changes',
  width: 160,
  textPadding: '8px 16px 8px 2px',
  icon: <SaveIcon color={theme.palette.white} width={16} />,
  ...btnProps,
};

export const annotationsBtnProps = {
  ...btnProps,
  textColor: theme.palette.white,
  text: 'New Annotation',
  textPadding: '8px 16px 8px 5px',
  width: 180,
  icon: <PlusIcon color='white' width={16} />,
};

export const uploadBtnProps = {
  ...btnProps,
  textPadding: '8px 16px 8px 0px',
  text: 'Upload .srt',
  width: 150,
  icon: <UploadIcon width={16} />,
};
